import { Body1 } from "../typography/Body1.js";
import radio_module_default from "./radio.module.js";
import { Radio } from "@mantine/core";
import { jsx } from "react/jsx-runtime";

//#region src/components/radio/Radio.tsx
const Radio$1 = ({ label, disabled, checked, size, value, error, onBlur, onChange, onFocus, "data-testid": testId }) => {
	return /* @__PURE__ */ jsx(Radio, {
		label: typeof label === "string" ? /* @__PURE__ */ jsx(Body1, {
			inline: true,
			children: label
		}) : label,
		disabled,
		classNames: radio_module_default,
		variant: "outline",
		checked,
		size,
		value,
		error,
		onBlur,
		onChange,
		onFocus,
		"data-testid": testId
	});
};

//#endregion
export { Radio$1 as Radio };